import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useInstantSearch } from 'react-instantsearch';

const ProductSearchCount = ({ title, indexClick, selectedOption, id }) => {
  const { results } = useInstantSearch();
  const isSelected = selectedOption === id;
  const count = results?.nbHits || 0;

  const handleIndexClick = useCallback(() => {
    indexClick(id);
  }, [id, indexClick]);

  return (
    <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand">
      <button
        type="button"
        className={classNames('w-full bg-white text-center lg:text-left', {
          'font-bold': isSelected,
        })}
        onClick={handleIndexClick}
      >
        {`${title} (${count})`}
      </button>
    </div>
  );
};

export default ProductSearchCount;
